import * as React from "react";
import { Card, Link, Stack, Typography } from "@mui/material";
import { useParams, useSearchParams, Link as RouterLink } from "react-router-dom";
import { SimpleBreadcrumbs } from "../../components/navigation/simpleBreadcrumbs";
import StandardLayout from "../../layouts/standard";
import OrderDetailDataGrid from "./orderDetailDataGrid";
import { useGetOrderDetailsQuery } from "../../services/cclTokenedAssessmentApi";
import { UserClaimsService } from "../../services/currentUserService/currentUserService";

interface OrderDetailProps {}

const OrderDetail: React.FC<OrderDetailProps> = () => {
    const { orderNumber } = useParams<{ orderNumber: string }>();
    const [searchParams] = useSearchParams();
    const claimsService = React.useMemo(() => new UserClaimsService(), []);
    const queryGroupId = Number(searchParams.get("groupId"));
    const groupKey = Number.isFinite(queryGroupId) && queryGroupId > 0
        ? queryGroupId
        : claimsService.GetCurrentUserAssesmentAdminGroupId();
    const groupName = searchParams.get("groupName") ?? "";

    const { data, isLoading } = useGetOrderDetailsQuery(
        { groupKey, orderId: orderNumber ?? "" },
        { skip: !orderNumber || !groupKey || !Number.isFinite(groupKey) },
    );

    const inventoryBackUrl = groupName && queryGroupId > 0
        ? `/inventory?groupId=${queryGroupId}&groupName=${encodeURIComponent(groupName)}`
        : "/inventory";

    const breadcrumbs = (
        <SimpleBreadcrumbs>
            <Typography variant="h6" color="text.primary">
                <Link component={RouterLink} to="/inventory">
                    Inventory
                </Link>
            </Typography>
            {groupName && queryGroupId > 0 && (
                <Typography variant="h6" color="text.primary">
                    <Link component={RouterLink} to={inventoryBackUrl}>
                        {groupName}
                    </Link>
                </Typography>
            )}
            <Typography variant="h6" color="text.primary">
                Order Detail ({orderNumber})
            </Typography>
        </SimpleBreadcrumbs>
    );

    return (
        <StandardLayout breadcrumbs={breadcrumbs}>
            <Stack height={1} width={1}>
                <Card
                    sx={{
                        width: 1,
                        height: 1,
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <OrderDetailDataGrid rows={data ?? []} isLoading={isLoading} />
                </Card>
            </Stack>
        </StandardLayout>
    );
};

export default OrderDetail;
